import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons';

import { Alert, Button, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../../hooks';
import { Theme } from '../../state';

type CSSRSPromptAlertProps = {
  onClose: () => void;
  patientName: string;
  onAdministerCSSRS: () => void;
  heading: string;
  body: string;
  callToAction: string;
  className?: string;
};

export function CSSRSPromptAlert({
  onClose,
  patientName,
  onAdministerCSSRS,
  heading,
  body,
  callToAction,
  className,
}: CSSRSPromptAlertProps) {
  const { theme } = useTheme();
  return (
    <Alert
      actions={
        <Button className='whitespace-nowrap' use='secondary' onClick={onAdministerCSSRS}>
          {callToAction}
        </Button>
      }
      className={cn(className, {
        'arc:bg-surface-inverseEmphasis arc:[&_h3]:text-text-inverse arc:[&_svg]:text-text-inverse arc:[&_div]:text-text-inverse':
          theme === Theme.DARK,
      })}
      heading={heading}
      headingAs='h3'
      icon={faHexagonExclamation}
      use='error'
      onClose={onClose}
    >
      <span className='fs-exclude data-dd-privacy'>{patientName || 'Your client'}</span> {body}
    </Alert>
  );
}
